import { service, formService } from '@/data/index';
import { mcesBaseUrl, menhuBaseUrl } from '@/config';
/**
 * @function getTeacherList 是否显示教师授权
 * @returns {*}
 */

export function orgCheckEmes() {
  return service.get('org/checkEmes');
}
/* 班级管理 */

/*
 * 年级列表
 */

export function getGradeList() {
  return service.get('/school/grade/list');
}
/*
 * 添加班级
 */

export function setAddClass(data) {
  return service.post('/school/class/addClass', data);
}
/*
 *  获取班级列表
 */

export function getClassListNew(data) {
  return service.post('/school/class/listNew', data);
}
/*
 *   修改班级名称
 */

export function setUpdateClassName(data) {
  return service.get('/school/class/updateClassName', data);
}
/*
 *   删除班级
 */

export function setClassDelete(data) {
  return service.get('/school/class/delete', data);
}
/* 科目管理 */

/*
 *  获取年级课目列表
 */

export function getGradeSubjectByOrgCode() {
  return service.get('/school/schoolSubject/gradeSubjectByOrgCode');
}
/*
 *  获取课程列表
 */

export function getSchoolSubjectList(data) {
  return service.get('/school/schoolSubject/list', data);
}
/*
 *  新增修改科目
 */

export function setSchoolSubjectSave(data) {
  return service.post('/school/schoolSubject/save', data);
}
/*
 *  启用/禁用科目
 */

export function subjectUpdateStatus(data) {
  return service.get('/school/schoolSubject/updateStatus', data);
}
/*
 *  获取年级已选课目
 */

export function getGradeSubjectList(data) {
  return service.get('/school/schoolSubject/gradeSubjectList', data);
}
/*
 *  获取 年级课目关联
 */

export function setGradeAddSubject(data) {
  return service.get('/school/grade/addSubject', data);
}
export function getMenuByUser(data) {
  return service.get('admin/menu', data);
} // 新手引导接口

export function getPagePointer(data) {
  return formService({
    baseURL: mcesBaseUrl,
    url: 'guide/getGuides',
    params: data
  });
} // 新手引导是否已读接口

export function guideIsRead(data) {
  return formService({
    baseURL: mcesBaseUrl,
    url: 'guide/isRead',
    params: data
  });
} // 已阅读操作指引

export function guideHaveRead(data) {
  return formService({
    baseURL: mcesBaseUrl,
    url: 'guide/haveRead',
    method: 'post',
    data: data
  });
} // 获取机构背景、logo

export function getOrgAssets(data) {
  return service.get('setting/org', data);
} // 获取门户网站信息

export function queryClientInfo(data) {
  return service({
    baseURL: menhuBaseUrl,
    url: 'api/data/clientInfo',
    method: 'get',
    params: data
  });
}